import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch, useAppSelector } from '../hooks';
import { DeviceButton2 } from '../components/DeviceButton';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { actionOnOff } from '../actions/ActionOnOff';
import { NexaDimmerDialog } from './NexaDimmerDialog';
import { showDialog } from '../reducers/app';
export const EntityNexaDim = props => {
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    const dispatch = useAppDispatch();
    if (props.entity.title !== 'onoff?' || props.actionOnOff.title !== 'onoff' || props.actionLevel.title !== 'level') {
        return null;
    }
    const value = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'enum' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value : undefined;
    let s1, s2;
    if (value === 'on') {
        s1 = undefined;
        s2 = 'on';
    }
    else if (value === 'off') {
        s1 = 'off';
        s2 = undefined;
    }
    else {
        s1 = undefined;
        s2 = undefined;
    }
    return (_jsxs("div", { className: "transmitter-buttons", children: [_jsxs("div", { className: "lw-button-group", children: [_jsxs("button", { className: "lw-button", onClick: () => dispatch(showDialog('nexadim_' + props.actionLevel.id)), children: ["Dim", _jsx("span", { className: "caret" })] }), _jsx(DeviceButton2, { state: s1, onClick: () => dispatch(actionOnOff(props.actionOnOff.id, false)), children: "Av" }), _jsx(DeviceButton2, { state: s2, onClick: () => dispatch(actionOnOff(props.actionOnOff.id, true)), children: "P\u00E5" })] }), _jsx(NexaDimmerDialog, { actionLevel: props.actionLevel })] }));
};
